import { render, staticRenderFns } from "./a-header.vue?vue&type=template&id=b1a0c20e&scoped=true&"
import script from "./a-header.vue?vue&type=script&lang=js&"
export * from "./a-header.vue?vue&type=script&lang=js&"
import style0 from "./a-header.vue?vue&type=style&index=0&id=b1a0c20e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a0c20e",
  null
  
)

export default component.exports